<template>
  <b-card
    :title="panel.name"
    class="h-100"
    body-class="d-flex flex-column align-items-start"
  >
    <PanelActions
      :deleteUrl="deleteUrl"
      :name="panel.name"
      :prompt="panel.prompt"
      class="position-absolute p-0"
      style="top:0.4rem; right:0.4rem;"
    />
    <EntityBadgeSet
      :entities="entities"
      style="z-index:1;"
    />
    <div class="flex-grow-1 w-100 mt-n1-5" style="min-height:0; position: relative;">
      <CustomChart
        :panelType="panel.type"
        :data="data"

        class="h-100 w-100"
        style="min-height:0; z-index:0;"
      />
    </div>
  </b-card>
</template>

<script>
import CustomChart from '@/xvisor/components/custom/CustomChart.vue';
import EntityBadgeSet from '@/xvisor/components/custom/EntityBadgeSet.vue';
import PanelActions from '@/xvisor/components/custom/PanelActions.vue';
import granularity from '@/xvisor/utilities/granularity';

// import panelData from '@/xvisor/components/custom/panelData2.json';

export default {
  components: {
    CustomChart,
    EntityBadgeSet,
    PanelActions,
  },
  props: {
    panel: {
      type: Object,
      required: true,
    },
    timeRange: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: {},
      entities: [],
    };
  },
  computed: {
    dataUrl() {
      return `/dashboards/panels/${this.panel.id}/data.json`;
    },
    deleteUrl() {
      return `/dashboards/panels/${this.panel.id}`;
    },
    entitiesUrl() {
      return `/dashboards/panels/${this.panel.id}/entities.json`;
    },
    httpParams() {
      return {
        params: {
          start: this.timeRange.start.toISOString(),
          end: this.timeRange.end.toISOString(),
          stepMinutes: granularity.granularity24(this.timeRange),
        },
      };
    },
  },
  methods: {
    httpGet() {
      // this.data = panelData;
      this.$http
        .get(this.dataUrl, this.httpParams)
        .then((response) => {
          // console.log('fetching ts data'); // eslint-disable-line no-console
          this.data = response.data;
          // console.log(`done fetching ts data: ${this.ts}`); // eslint-disable-line no-console
        });
      this.$http
        .get(this.entitiesUrl)
        .then((response) => {
          // console.log('fetching ts data'); // eslint-disable-line no-console
          this.entities = response.data;
          // console.log(`done fetching ts data: ${this.ts}`); // eslint-disable-line no-console
        });
    },
  },
  watch: {
    timeRange() {
      this.httpGet();
    },
  },
  mounted() {
    this.httpGet();
  },
};
</script>
